import Proposal from "./Proposal";
export default Proposal;
